<template>
  <div class="modal-container" :style="modalStyle">
    <div class="modal-header-box" @mousedown="startDrag">
      <div class="modal-header">
        <div class="modal-title">{{ title }}</div>
        <button class="modal-close" @click="closeModal">&times;</button>
      </div>
    </div>

    <div class="modal-content">
      <slot></slot>
    </div>

    <div class="modal-footer">
      <slot name="footer">
        <button class="btn" @click="submit">提交</button>
      </slot>
    </div>

    <div class="resize-handle" @mousedown="startResize"></div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    title: {
      type: String,
      default: "模态框标题",
    },
    size: {
      type: String,
      default: "medium", // small, medium, large
    },
  },
  data() {
    return {
      isDragging: false,
      isResizing: false,
      startX: 0,
      startY: 0,
      startWidth: 0,
      startHeight: 0,
      startLeft: 0,
      startTop: 0,
      modalStyle: {
        left: "0px",
        top: "0px",
        width: "1200px",
        height: "660px",
      },
    };
  },
  mounted() {
    this.setInitialSize();
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
    document.addEventListener("keyup", this.handleKeyUp);

    // 初始位置居中
    this.centerModal();
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
    document.removeEventListener("keyup", this.handleKeyUp);
  },
  methods: {
    setInitialSize() {
      const sizeMap = {
        small: { width: "400px", height: "300px" },
        medium: { width: "500px", height: "400px" },
        large: { width: "1000px", height: "660px" },
      };

      const size = sizeMap[this.size] || sizeMap.medium;
      this.modalStyle.width = size.width;
      this.modalStyle.height = size.height;
    },

    centerModal() {
      const modalWidth = parseInt(this.modalStyle.width);
      const modalHeight = parseInt(this.modalStyle.height);

      this.modalStyle.left = `${window.innerWidth - modalWidth - 50}px`;
      this.modalStyle.top = `${(window.innerHeight - modalHeight) / 2}px`;
      this.$emit("position-change", {
        x: parseInt(this.modalStyle.left),
        y: parseInt(this.modalStyle.top),
        width: modalWidth,
        height: modalHeight,
      });
    },

    resetModal() {
      this.setInitialSize();
      this.centerModal();
    },

    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startLeft = parseInt(this.modalStyle.left);
      this.startTop = parseInt(this.modalStyle.top);
    },

    startResize(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startWidth = parseInt(this.modalStyle.width);
      this.startHeight = parseInt(this.modalStyle.height);
      this.startLeft = parseInt(this.modalStyle.left);
      this.startTop = parseInt(this.modalStyle.top);

      e.stopPropagation();
    },

    handleMouseMove(e) {
      if (this.isDragging) {
        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;

        this.modalStyle.left = `${this.startLeft + dx}px`;
        this.modalStyle.top = `${this.startTop + dy}px`;

        this.$emit("position-change", {
          x: this.startLeft + dx,
          y: this.startTop + dy,
          width: parseInt(this.modalStyle.width),
          height: parseInt(this.modalStyle.height),
        });
      }

      if (this.isResizing) {
        const dx = e.clientX - this.startX;
        const dy = e.clientY - this.startY;

        const newWidth = Math.max(300, this.startWidth + dx);
        const newHeight = Math.max(200, this.startHeight + dy);

        this.modalStyle.width = `${newWidth}px`;
        this.modalStyle.height = `${newHeight}px`;

        this.$emit("position-change", {
          x: parseInt(this.modalStyle.left),
          y: parseInt(this.modalStyle.top),
          width: newWidth,
          height: newHeight,
        });
      }
    },

    handleMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
    },

    handleKeyUp(e) {
      if (e.key === "Escape") {
        this.closeModal();
      }
    },

    closeModal() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  background: #2055b5;
  border-radius: 4px;
  border: 1px solid #1872d8;
  padding: 6px 15px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s;
  margin: 5px;
  font-family: MicrosoftYaHei;
  font-size: 15px;
  color: #ffffff;
}

.btn:hover {
  background-color: #2980b9;
  transform: translateY(-2px);
}
.modal-container {
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 400px;
  min-height: 300px;
  max-width: 90vw;
  max-height: 90vh;
  position: fixed;
  transition: transform 0.2s ease;
  z-index: 1000;
  //box-shadow: 0px 0px 21px 0px #5668d0;
  box-shadow: 0 0px 8px #5668d0;
  border-radius: 10px;
  border: 1px solid #426dd3;
}
.modal-header-box {
  padding: 0 20px;
}
.modal-header {
  padding: 16px 0;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  border-bottom: 1px solid #bebebe;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 500;
}

.modal-close {
  background: none;
  border: 1px solid #939393;
  color: #939393;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  border-radius: 50%;
}

.modal-close:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.modal-content {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  //background-color: #fafafa;
}

.modal-footer {
  padding: 16px 20px;
  //background-color: #f8f9fa;
  display: flex;
  justify-content: center;
}
</style>